class ProductCard extends HTMLElement {
  static selectors = {
    loader: 'theme-loader',
    variants: 'input[name="id"]',
    form: 'form'
  }
  loader; variants; form;
  
  constructor() {
    super();
    this.loader = this.querySelector(ProductCard.selectors.loader);
    this.variants = this.querySelectorAll(ProductCard.selectors.variants);
    this.form = this.querySelector(ProductCard.selectors.form);

    this.addEvents();
  }

  addEvents = () => {
    this.variants.forEach(variant => {
      variant.addEventListener('change', () => this.addTocart());
    });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.dispatchEvent(new CustomEvent(Utils.E_PRODUCT_VIEW, { detail: this }));
        }
      });
    });

    observer.observe(this);

    // --------------------------------------------------------------------------------------------------------
    const productId = this.closest(".product-card").getAttribute("id");
    if(productId){
        this.querySelector("a").addEventListener("click", function (e) {
          e.stopPropagation();
          localStorage.setItem("clickedProductId", productId);
        });
    }
    // --------------------------------------------------------------------------------------------------------

    this.addEventListener('click', () => this.productClick());
  }

  productClick = () => {
    const data = {
      sku: this.dataset.analyticsSku,
      title: this.dataset.analyticsTitle,
      price: this.dataset.analyticsPrice,
      vendor: this.dataset.analyticsVendor,
      type: this.dataset.analyticsType,
      id: this.dataset.analyticsId,
      variant: this.dataset.analyticsVariant
    };
    window.dispatchEvent(new CustomEvent(Utils.E_PRODUCT_CLICK, { detail: data }));
    Shopify.analytics.publish(Utils.E_PRODUCT_CLICK, data);
  }

  addTocart = () => {
    if(this.form != undefined){
      Utils.addTocart({
        form: this.form,
        before: () => {
          this.showLoader();
        },
        success: (data) => {
          this.form.reset();
        },
        finally: () => {
          this.hideLoader();
        }
      });
    }
  }

  showLoader = () => {
    if(this.loader != undefined)
      this.loader.show();
  }

  hideLoader = () => {
    if(this.loader != undefined)
      this.loader.hide();
  }
}
if (!window.customElements.get("product-card")) {
  window.customElements.define("product-card", ProductCard);
}